import { getConfiguration as getConfigurationFromDraft } from '@/model/draft/getConfiguration';
import { StoreState } from '@/redux/types';
import { getDraft } from './getDraft';

export function getConfiguration(state: StoreState, configurationId: number) {
  return getConfigurationFromDraft(getDraft(state), configurationId);
}
